import React, {Component} from "react";
import {
    Card,
    CardBody,
    CardSubtitle,
    CardTitle
} from "reactstrap";
import defaultBookImage from "../assets/default-book-image.png";
import {Chip} from "@mui/material";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

class Book extends Component {

    render() {
        // Parent Variables
        let book = this.props.book || [];

        // Parent Functions
        const openBookModal = this.props.openBookModal;

        const getTitle = (title) => {
            if (title.length > 25) {
                return title.substring(0, 25) + "...";
            }
            return title;
        }

        const getAuthors = (authors) => {
            if (authors && authors.join(", ").length > 20) {
                return authors.join(", ").substring(0, 20) + "...";
            }

            if (authors) {
                return authors.join(", ");
            }

            return "Unknown";
        }

        const isReading = (book) => {
            return book.currentlyReading;
        }

        const hasCompleted = (book) => {
            return book.completed;
        }

        return (
            <Card className="book-card">

                {book.rating > 0 &&
                    <div className="rating">
                        <Chip icon={<FontAwesomeIcon icon="star"/>} label={book.rating} className="rating-chip"/>
                    </div>
                }

                <div className="book-status">
                    {isReading(book) &&
                        <Chip label={<FontAwesomeIcon icon="book-open"/>} className="reading-chip"/>
                    }

                    {hasCompleted(book) &&
                        <Chip label={<FontAwesomeIcon icon="check"/>} className="completed-chip"/>
                    }
                </div>

                <div className="card-image" onClick={() => openBookModal(book)}>
                    {book.coverData ?
                        <img
                            src={book.coverData}
                            alt={book.book.title}
                            width="100%"
                            height="auto"/>
                        :
                        <img
                            src={defaultBookImage}
                            alt="Default book cover"
                            width="100%"
                            height="auto"/>
                    }
                    <div className="overlay"/>
                </div>

                <CardBody className="book-card-body">
                    <CardTitle tag="h5">
                        {getTitle(book.book.title)}
                    </CardTitle>

                    <CardSubtitle className="mb-2 text-muted" tag="h6">
                        {getAuthors(book.book.author_name)}
                    </CardSubtitle>
                </CardBody>

            </Card>
        );
    }
}

export default Book;
